import React, { Component } from 'react';

import classNames from 'classnames';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './PanelHeader.scss';

class PanelHeader extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const { children, className } = this.props;

    const classComponent = classNames('panel__header', className);

    return (
      <div className={classComponent}>
        {typeof children === 'string' ? <I18n label={children} /> : children}
      </div>
    );
  }
}

export default PanelHeader;
